/**
 * bootprompt.js locale configuration
 * locale : Hungarian
 * author : Márk Sági-Kazár
 */

import { addLocale } from "../bootprompt";

addLocale("hu", {
  OK: "OK",
  CANCEL: "Mégsem",
  CONFIRM: "Megerősít",
});
